<template>
  <div class="subscription-landing subscription-landing--decanter">
    <section class="hero-video">
      <div class="site-width">
        <div class="hero-video--text">
          <img src="~assets/images/club-decanter-black.svg" />
          <h1>Decanter’s Best Wines. Before They Disappear.</h1>
          <div class="button-link">
            <p>
              <a
                href="#"
                class="button primary"
                @click.prevent="signup(membershipPlanSlug)"
                >{{ ctaText(isFull) }}</a
              >
            </p>
            <p v-if="hasVisibleGiftTerm" class="gift-alternative">
              <nuxt-link to="/wine-club/gifting/decanter/" class="button">
                Or gift it
              </nuxt-link>
            </p>
          </div>
        </div>
        <div class="hero-video--video">
          <video width="100%" autoplay="" muted="" loop="" playsinline="">
            <source src="~assets/images/decanter1.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
    <section class="shaded decanter-intro">
      <div class="site-width text-center">
        <header class="section_heading--has_heading section_heading">
          <h2><em>Decanter</em> Wine Club</h2>
          <p>
            Perfectly curated by Wine Access and
            <em>Decanter’s</em>
            globally renowned team, these are the tasting-panel all-stars, the
            critic favorites whose ratings will send collectors clamoring.
            Consider this your inside track to top-scoring wines from
            <em>Decanter’s</em>
            latest issues.
          </p>
        </header>
      </div>
    </section>
    <section class="white">
      <div class="site-width text-center">
        <div>
          <h2>
            Six Critic-Favorite Wines.
            <br />
            Delivered Every Three Months.
          </h2>
        </div>
        <div class="bordered-callout">
          <p>$250 – 300 plus tax per 6-bottle shipment.</p>
        </div>
        <div class="button-link">
          <p>
            <span class="button primary" @click="signup(membershipPlanSlug)">{{
              ctaText(isFull)
            }}</span>
          </p>
          <p v-if="hasVisibleGiftTerm" class="gift-alternative">
            <nuxt-link to="/wine-club/gifting/decanter/" class="button">
              Or gift it
            </nuxt-link>
          </p>
        </div>

        <div class="row">
          <h3 class="section_heading-seccondary">Recent Shipments</h3>

          <ul class="generic-grid generic-grid__3-col">
            <li>
              <div class="restaurant">
                <span class="image">
                  <img src="~assets/images/club-decanter-photo1.jpg" />
                </span>
              </div>
            </li>
            <li>
              <div class="restaurant">
                <span class="image">
                  <img src="~assets/images/club-decanter-photo2.jpg" />
                </span>
              </div>
            </li>
            <li>
              <div class="restaurant">
                <span class="image">
                  <img src="~assets/images/club-decanter-photo3.jpg" />
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="memberbenefits shaded">
      <div class="site-width text-center">
        <div>
          <h2>
            <strong>
              <em>Member Benefits</em>
            </strong>
          </h2>
        </div>
        <div class="row icon-grid">
          <div class="columns medium-4">
            <div class="icon">
              <img
                src="~assets/images/wa-icon-club-discount.svg"
                alt="Percent symbol"
                class="icon-desktop lazyLoad"
              />
              <img
                src="~assets/images/wa-icon-club-discount-mobile.svg"
                alt="Percent symbol"
                class="icon-mobile lazyLoad"
              />
            </div>
            <p>10% off Wine Access purchases *</p>
          </div>
          <div class="columns medium-4">
            <div class="icon">
              <img
                src="~assets/images/wa-icon-club-video.svg"
                alt="Video camera icon"
                class="icon-desktop lazyLoad"
              />
              <img
                src="~assets/images/wa-icon-club-video-mobile.svg"
                alt="Video camera icon"
                class="icon-mobile lazyLoad"
              />
            </div>
            <p>Tasting videos for each wine</p>
          </div>
          <div class="columns medium-4">
            <div class="icon">
              <img
                src="~assets/images/wa-icon-club-shipping.svg"
                alt="Box icon"
                class="icon-desktop lazyLoad"
              />
              <img
                src="~assets/images/wa-icon-club-shipping-mobile.svg"
                alt="Box Icon"
                class="icon-mobile lazyLoad"
              />
            </div>
            <p>Complimentary shipping</p>
          </div>
        </div>
      </div>
    </section>
    <section class="benefits">
      <header class="section_heading--has_heading section_heading">
        <h2>
          About Decanter
          <span class="secondary-subhead"
            >Passionate About Wine Since 1975</span
          >
        </h2>
        <p>
          <em>Decanter</em>
          is Europe’s best-selling wine magazine and host to the world’s largest
          and most influential wine competition. Their tasting panels are
          composed of some of the world’s most discriminating palates—Masters of
          Wine, sommeliers, and esteemed regional experts. Every panel is
          different, blind-tasting thousands of stellar wines, and recommending
          only the finest.
        </p>
      </header>

      <div class="site-width">
        <div class="image-full">
          <img
            src="~/assets/images/decanter-xl.jpg"
            alt="People at a wine tasting"
            role="presentation"
            class="show-for-xlarge-up"
          />
          <img
            src="~/assets/images/decanter-l.jpg"
            alt="People at a wine tasting"
            role="presentation"
            class="show-for-large-only"
          />
          <img
            src="~/assets/images/decanter-m.jpg"
            alt="People at a wine tasting"
            role="presentation"
            class="show-for-medium-only"
          />
          <img
            src="~/assets/images/decanter-s.jpg"
            alt="People at a wine tasting"
            role="presentation"
            class="hide-for-medium-up"
          />
        </div>
      </div>
    </section>

    <ExpertsSection />
    <section class="callout">
      <div class="cta-callout">
        <div class="text">
          <h2>Get First Access to Top-Rated Wines</h2>
          <div class="button-link">
            <p>
              <span
                class="button primary"
                @click="signup(membershipPlanSlug)"
                >{{ ctaText(isFull) }}</span
              >
            </p>
            <p v-if="hasVisibleGiftTerm" class="gift-alternative">
              <nuxt-link to="/wine-club/gifting/decanter/" class="button">
                Or gift it
              </nuxt-link>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ga4 from '#common/utils/ga4'

export default {
  name: 'DecanterIndex',
  components: {
    ExpertsSection: defineAsyncComponent(
      () => import('@/components/Club/ExpertsSection'),
    ),
  },
  async setup() {
    const { data: decanterData } = await useAsyncData('decanter', () =>
      $fetch('/api/membership/decanter/'),
    )

    return {
      membershipPricing: computed(() => decanterData.value?.pricing_info || ''),
      hasVisibleGiftTerm: computed(
        () => decanterData.value?.has_visible_gift_term || false,
      ),
      membershipPlanSlug: computed(
        () => decanterData.value?.plans[0].slug || '',
      ),
      isFull: computed(() => decanterData.value?.plans.every((p) => p.is_full)),
    }
  },
  data() {
    return {
      modalTheme: {
        title: 'Decanter’s Best Wines. Before They Disappear.',
        container: {
          classes: 'wineclub-form decanter',
        },
        login: {
          submitButton: {
            classes: 'primary continue',
          },
        },
        register: {
          submitButton: {
            classes: 'primary continue',
            label: 'Continue',
          },
        },
        emailCheck: {
          submitButton: {
            classes: 'primary continue',
            label: 'Continue',
          },
        },
      },
    }
  },
  head() {
    return {
      title: 'The Decanter Wine Club by Wine Access',
    }
  },
  mounted() {
    ga4.trackViewClub({ slug: 'decanter' })
  },
  methods: {
    ctaText(isFull) {
      if (isFull) {
        return 'Join The Waiting List'
      } else {
        return 'Sign Up Now'
      }
    },
    openLoginModal() {
      this.$auth.openAuthModal({
        theme: this.modalTheme,
        redirect: '/decanter/join/',
        isClub: true,
      })
    },
    signup(planSlug) {
      this.$store.dispatch('setWineClubPreselectedPlan', planSlug)
      if (!this.$auth.loggedIn) {
        this.openLoginModal()
      } else {
        this.$router.push('/decanter/join/')
      }
    },
  },
}
</script>

<style scoped></style>
